// src/data/bigStore.js
import { db } from "./firebase";
import { doc, getDoc } from "firebase/firestore";

function parseAllOld(raw) {
  if (Array.isArray(raw)) {
    const looksLikeStrings = raw.every((x) => typeof x === "string");
    if (!looksLikeStrings) {
      return raw
        .map((item) => {
          const name = item && typeof item.name === "string" ? item.name.trim() : "";
          const infoArr = Array.isArray(item?.info)
            ? item.info.map((s) => String(s ?? "").trim()).filter(Boolean)
            : [];
          if (!name && infoArr.length === 0) return null;
          return { name, info: infoArr };
        })
        .filter(Boolean);
    }
    // treat as CSV lines if array of strings
    raw = raw.join("\n");
  }
  if (typeof raw === "string") {
    const lines = raw.split(/\r?\n/);
    const parsed = [];
    let current = null;
    for (let rawLine of lines) {
      const line = String(rawLine ?? "");
      if (!line) continue;
      const commaIdx = line.indexOf(",");
      if (commaIdx === -1) continue;
      const col1 = line.slice(0, commaIdx).trim();
      const col2 = line.slice(commaIdx + 1).trim();
      if (col1) {
        current = { name: col1, info: [] };
        parsed.push(current);
        if (col2) current.info.push(col2);
      } else if (current && col2) {
        current.info.push(col2);
      }
    }
    return parsed;
  }
  return [];
}

export async function listBigFormulations() {
  const ref = doc(db, "Big records", "BigRecords");
  const snap = await getDoc(ref);
  if (!snap.exists()) return [];
  const data = snap.data() || {};
  const raw = data["ALL-OLD"];
  return parseAllOld(raw);
}
